import React, { useEffect, useRef } from "react";
import SimpleTextEditor from "./SimpleTextEditor";

export default function NotesIngestModal({
  open,
  value,
  onChange,
  onClose,
  onSubmit,
  loading = false,
  error = ""
}) {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape" && open) {
        onClose?.();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="notes-ingest-modal-overlay"
      ref={overlayRef}
      onClick={(event) => {
        if (event.target === overlayRef.current) {
          onClose?.();
        }
      }}
    >
      <div className="notes-ingest-modal">
        <div className="notes-ingest-modal-head">
          <div>
            <h3>Import Meeting Notes</h3>
            <p className="muted">
              Paste notes from workshops or stakeholder interviews. AI will update questionnaire answers,
              incidents, and report sections in one pass.
            </p>
          </div>
          <button type="button" className="notes-ingest-modal-close" onClick={onClose} aria-label="Close dialog">×</button>
        </div>

        <label className="notes-ingest-field">
          <span>Notes</span>
          <SimpleTextEditor
            rows={10}
            value={value}
            onChange={(nextValue) => onChange?.(nextValue)}
            placeholder="Paste your meeting notes here..."
            ariaLabel="meeting-notes-editor"
            minHeight="200px"
          />
        </label>

        {error ? <p className="error">{error}</p> : null}

        <div className="notes-ingest-actions">
          <button type="button" className="button-link ghost" onClick={onClose} disabled={loading}>Cancel</button>
          <button type="button" onClick={onSubmit} disabled={loading || !String(value || "").trim()}>
            {loading ? "Processing..." : "Generate Updates"}
          </button>
        </div>
      </div>
    </div>
  );
}
